import React from 'react';
import { useTranslation } from 'next-i18next';

import { IDocListData, searchDocList, ECmsId } from '../../api/investorApi';
import { serverSideTranslation } from '../../util/next';
import { DocList } from '../../modules/Investor';
import Page from '../../components/Layout/Page';

interface IProps {
  data: IDocListData;
}

const cmsId = ECmsId.Result;

function Results(props: IProps) {
  const description =
    '美团企业官网，美团官方信息发布平台，美团香港交易所上市信息，最新估值、市值、股票、股权、融资、投资、收购、并购信息发布平台，美团年报，招股书，招股文件下载官方平台。美团是中国领先的生活服务电子商务平台，用科技连接消费者和商家，提供服务以满足人们日常「吃」的需求，并进一步扩展至多种生活和旅游服务。美团的使命是“帮大家吃得更好，生活更好”。';

  const { data } = props;
  const { years, docs } = data;

  const { t } = useTranslation('investor');
  const sectionList = t('sectionList', { returnObjects: true }) as any[];
  const title = t('titleIR');

  return (
    <Page description={description} title={title}>
      <DocList title={sectionList[2].title} cmsId={cmsId} type="uncovered" years={years} content={docs} />
    </Page>
  );
}

export async function getServerSideProps({ locale }: any) {
  const data = await searchDocList({
    cmsId,
    locale,
  });

  return {
    props: {
      data,
      ...(await serverSideTranslation(locale, ['investor', 'cookie', 'common'])),
    },
  };
}

export default Results;
